var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.config.ui_version==3.5)?_c('index3Dian5',{attrs:{"active":_vm.active}}):_c('indexGeneral',{attrs:{"active":_vm.active}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }